<template>
  <v-col>
    <QuoteForm
      :quote="quoteData"
      :supplier-product-data="supplierProductData"
      @update:quote="updateQuote"
      @update:supplier-product-data="updateSupplierProductData"
    />
  </v-col>
</template>

<script>
import { QuoteForm } from "@/modules/quotes";
import utils from "@/modules/quotes/components/utils";
export default {
  components: {
    QuoteForm,
  },
  data() {
    const period = {
      startYear: new Date().getFullYear().toString(),
      startMonth: null,
      startDay: null,
      endYear: null,
      endMonth: null,
      endDay: null,
    };
    const periodName = utils.getFrenchArrivalLabel(period);

    return {
      supplierProductData: {},
      quoteData: {
        id: null,
        environment: null,
        reference: null,
        client: {},
        cityStart: null,
        cityEnd: null,
        version: null,
        period: period,
        periodName: periodName,
        nights: null,
        accommodations: [],
        title: null,
        folder: null,
        peopleRanges: [],
        program: {
          hideReference: false,
          introduction: "",
          supernatureSuccesses: "",
        },
        costs: [],
        logisticsCosts: [],
        margin: {
          status: "fixed",
          percentFixed: 0,
          percentDynamic: [],
          perPax: [],
          perGroup: [],
        },
        overviewOptions: {
          included: null,
          excluded: null,
          disclaimer: null,
        },
        notes: "",
        discountMargin: 30,
        supplementTripleOverride: null,
        supplementQuadOverride: null,
      },
    };
  },
  computed: {},
  methods: {
    updateQuote(val) {
      this.quoteData = val;
    },
    updateSupplierProductData(val) {
      this.supplierProductData = val;
    },
  },
  mounted() {
    this.$root.$loading.open("Initializing new quote...");
    this.$store
      .dispatch("TripInclusionsStore/getTripInclusion", { env: this.$store.getters["AccountStore/environment"] })
      .then((tripInclusionsResponse) => {
        this.quoteData.overviewOptions.included = tripInclusionsResponse.included;
        this.quoteData.overviewOptions.excluded = tripInclusionsResponse.excluded;
        this.quoteData.overviewOptions.disclaimer = tripInclusionsResponse.disclaimer;

        const defaultRanges = [
          { min: "45", max: "54" },
          { min: "40", max: "44" },
          { min: "35", max: "39" },
          { min: "30", max: "34" },
          { min: "25", max: "29" },
          { min: "20", max: "24" },
        ];
        const defaultMarginPercentages = [0, 0, 0, 0, 0, 0];
        const defaultAccommodationTypes = [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5];

        this.quoteData.peopleRanges.push(...defaultRanges);
        this.quoteData.margin.percentDynamic.push(...defaultMarginPercentages);
        this.quoteData.accommodations.push(...defaultAccommodationTypes);
      })
      .finally(() => {
        this.$root.$loading.end();
      });
  },
};
</script>
